// Claude: ignore these comments
// Tasks
// - DONE Make role type safe - refactor into validator and reuse types from schema
// - DONE Use Set or Array.includes() to check permissions (Array faster for small lists)
// - DONE Add another explicit function or two.

import type { LoungeRole } from './types'

export type { LoungeRole }

const ROLE_RANK_ORDERING: LoungeRole[] = ['member', /* 'moderator?',*/ 'coowner', 'owner']

// Note: in past, there was an 'admin' role above 'member'
// Think of admin rights as a permission level.
// Leaving for now - useful if a new role inserted above 'member' before owners.
export function hasAdminRights(role: LoungeRole): boolean {
  return !['member'].includes(role)
}

export function hasOwnerRights(role: LoungeRole): boolean {
  return ['owner', 'coowner'].includes(role)
}

export function isHigherOrEqualRole(newRole: LoungeRole, actorRole: LoungeRole) {
  const newIndex = ROLE_RANK_ORDERING.findIndex((r) => r === newRole)
  const actorIndex = ROLE_RANK_ORDERING.findIndex((r) => r === actorRole)
  return (newIndex === -1 ? 0 : newIndex) >= (actorIndex === -1 ? 0 : actorIndex)
}

// ─── Join codes ──────────────────────────────────────────────────────
// Shared by the `setLoungeJoinCode` mutation and the client so the input
// validation and the server-side check can never disagree.

export const LOUNGE_JOIN_CODE_MIN_LENGTH = 4
export const LOUNGE_JOIN_CODE_MAX_LENGTH = 10

export type LoungeJoinCodeFormatError = 'too_short' | 'too_long' | 'invalid_chars'

/** Join codes are case-insensitive; they are stored and looked up upper-cased. */
export function normalizeLoungeJoinCode(code: string): string {
  return code.trim().toUpperCase()
}

/** Returns the first format problem with an (already normalized) join code, or `null` if valid. */
export function getLoungeJoinCodeFormatError(code: string): LoungeJoinCodeFormatError | null {
  if (!/^[A-Z0-9]*$/.test(code)) return 'invalid_chars'
  if (code.length > LOUNGE_JOIN_CODE_MAX_LENGTH) return 'too_long'
  if (code.length < LOUNGE_JOIN_CODE_MIN_LENGTH) return 'too_short'
  return null
}
